module.exports = "https://dhstatic.bthome.com/prod/web/activity_h5/img/goods_2col.548822d963ea83fa.png";